// The consents card activation asks for, from the white label: each agreement the brand
// publishes in both languages gets its own checkbox; a brand without a cardholder agreement
// gets the generic terms checkbox instead. The activation page and the dashboard's activate
// dialog both ask through this, so they agree.
export const activationConsents = brand => {
  const both = (en, fr) => Boolean(brand && brand[en] && brand[fr]);
  const cardholderAgreement = both('activateCardholderAgreementEn', 'activateCardholderAgreementFr');
  return {
    electronicCom: both('activateElectronicComConsentEn', 'activateElectronicComConsentFr'),
    terms: !cardholderAgreement,
    cardholderAgreement,
    privacyPolicy: both('activatePrivacyPolicyEn', 'activatePrivacyPolicyFr'),
  };
};

// Whether every consent the brand asks for is ticked; checked holds the same keys as booleans.
export const activationConsentsAccepted = (brand, checked) => {
  const required = activationConsents(brand);
  return Object.keys(required).every(key => !required[key] || Boolean(checked[key]));
};
